import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import useReactRouter from 'use-react-router';
import { Button, Typography, TextField, Snackbar, Checkbox } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { makeStyles, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import './styles.css';

//Card
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';


//Merge
var merge = require('lodash.merge');

const theme = createMuiTheme({});

const useStyles = makeStyles(theme => ({

    //Stepper
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepperdiv: {
        marginRight: '15px',
        float: 'right',
    },

    //card
    cardroot: {
        minHeight: 465,
        height: '100%',
    },
}));

//Alert

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function EntityCreateForm(props) {

    const classes = useStyles();
    const { location, history } = useReactRouter();
    const reduxAuth = useSelector((state) => state.auth)
    const appcomponent = useSelector((state) => state.appcomponent)
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = React.useState({
        open: false,
        errmsg: null,
        api:''
      });

    //userAttributes
    const [userAttributes, setuserAttributes] = React.useState([])
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    //success alert

    const [openalert, setOpenAlert] = React.useState({
        open: false,
        msg: 'Configuration Saved',
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert({
            open: false,
        });
    };

    //create form static JSON

    const [jsonObj] = React.useState({
        _id: '',
        componentContextCode: '',
        domain: '',
        entityType: '',
        context1: '',
        context2: '',
        context3: '',
        relationship: '',
        role: '',
        app: '',
        isDuplicate: '',
        environmentId: '',
        isDuplicate: false,
        isPublished: true,
        jsonDocument: {
            id: "",
            name: "",
            type: "",
            // properties:"",
            data: {
                contexts: [{
                    context: {
                        component: "_DEFAULT",
                        role: "_DEFAULT",
                        tenant: "_DEFAULT",
                        domain: "_DEFAULT",
                        app: "_DEFAULT",
                        entityType: "_DEFAULT",
                        country: "_DEFAULT",
                        channel: "_DEFAULT",
                        relationship: "_DEFAULT",
                        user: "_DEFAULT"
                    },
                    jsonData: {}
                }]
            }
        }
    })

    const handleNext = (event) => {
        reduxAuth.fullscreentoggle=false
        history.push('./Config')
    };


    //Attribute List

    const [AttributeList, setAttributelist] = React.useState({
        AttributeList: []
    })


    const handleAttributes = (event, value) => {
        setuserAttributes(value)
    }

    //no of columns
    const [NoofColumns, setNoofColumns] = React.useState({
        NoofColumns: 3
    })

    const handleColumns = (event) => {
        let col = 3
        col = parseInt(event.target.value, 10)
        if (isNaN(col)) {
            col = 3
        }

        setNoofColumns({
            NoofColumns: col
        })
    }

    //Save Data
    const handleSaveClick = () => {


        let addjson = {
            "config": {
                "properties": {
                    "attributeNames": userAttributes,
                    "matchConfig": {
                        "allow-create": true,
                        "compare-title": "{[ECMCComTit]}",
                        "enable-match-step": true
                    },
                    "enableRelationshipsMatchMerge": false,
                    "noOfColumns": NoofColumns.NoofColumns
                }
            }
        }

        if (location.state && location.state.jsonDocument != "") {

            location.state.jsonDocument.data.contexts[0].jsonData = addjson;

            updateConfigAPI();


        }

        if (location.state && location.state.jsonDocument == "") {
            location.state.jsonDocument = jsonObj.jsonDocument
            location.state.jsonDocument.data.contexts[0].jsonData = addjson;
            updateConfigAPI();

        }

        if (location.state === undefined) {

            jsonObj.jsonDocument.id = props.data.computedName;
            jsonObj.jsonDocument.name = props.data.computedName;
            jsonObj.jsonDocument.type = "UiConfig";
            jsonObj.jsonDocument.data.contexts[0].context.component = props.data.componentContextCode;
            jsonObj.jsonDocument.data.contexts[0].context.role = props.data.role;
            jsonObj.jsonDocument.data.contexts[0].context.tenant = props.data.tenant;
            jsonObj.jsonDocument.data.contexts[0].context.domain = props.data.domain;
            jsonObj.jsonDocument.data.contexts[0].context.entityType = props.data.entityType;
            jsonObj.jsonDocument.data.contexts[0].context.relationship = props.data.relationship;
            jsonObj.jsonDocument.data.contexts[0].context.app = props.data.app;
            jsonObj.jsonDocument.data.contexts[0].context.user = props.data.user;

            jsonObj._id = props.data._id;
            jsonObj.isPublished = false;
            jsonObj.componentContextCode = props.data.componentContextCode;
            jsonObj.domain = props.data.domain;
            jsonObj.entityType = props.data.entityType;
            jsonObj.context1 = props.data.context1;
            jsonObj.context2 = props.data.context2;
            jsonObj.context3 = props.data.context3;
            jsonObj.relationship = props.data.relationship;
            jsonObj.role = props.data.role;
            jsonObj.app = props.data.app;
            jsonObj.isDuplicate = props.data.isDuplicate;
            jsonObj.environmentId = props.data.environmentId;

            jsonObj.jsonDocument.data.contexts[0].jsonData = addjson;
            location.state = jsonObj
            updateConfigAPI("add");
            // history.push("./ManageConfig")

        }
    }

    //Get existing attribute list
    const getAttributeList = () => {
        if (location.state) {
            if (location.state.jsonDocument != "") {
                setuserAttributes(location.state.jsonDocument.data.contexts[0].jsonData.config.properties.attributeNames)
                setNoofColumns({
                    NoofColumns: location.state.jsonDocument.data.contexts[0].jsonData.config.properties.noOfColumns
                })
            }

        }
    }

    //update config API
    const updateConfigAPI = (event) => {

        //update Config

        let url = "configurationUpdate"
        let postdata = null;
        if (event === "add") {
            postdata = {
                _id: props.data._id,
                jsonDocument: jsonObj.jsonDocument,
                isPublished: false,
                componentContextCode: props.data.componentContextCode,
                domain: props.data.domain,
                entityType: props.data.entityType,
                context1: props.data.context1,
                context2: props.data.context2,
                context3: props.data.context3,
                relationship: props.data.relationship,
                role: props.data.role,
                app: props.data.app,
                isDuplicate: props.data.isDuplicate,
                environmentId: props.data.environmentId,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            };
        }
        else {
            location.state.isPublished = false;
            postdata = {
                ...location.state,
                token: reduxAuth.token,
                userId: reduxAuth.userId
            }
        }


        axios.post(url, postdata)
            .then(editConfigResponse => {
                setOpenAlert({
                    open: true
                })
            })
            .catch(err => {
                console.log(err);
                if (typeof err.response != "object") {
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });

    }

    useEffect(() => {

        getAttributeList();

        //Get ContextList
        let url = "getContextList"
        let postdata = {
            userId: reduxAuth.userId,
            token: reduxAuth.token,
            environmentId: appcomponent.selectedEnvironment.tenantId,
        }

        axios.post(url, postdata)
            .then(contextList => {
                let clist = contextList.data.response[0];
                setAttributelist({
                    AttributeList: clist.attribute
                })
                // setLoader(false)
            })
            .catch(err => {
                if (typeof err.response != "object") {
                    setErrorMessage({
                        open: true,
                        api:'contextList',
                        errmsg:"Couldn't found context list please sync the tenant..."
                      })
                }
                else {
                    if (err.response.status === 403) {
                        dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
                }
            });


    }, []);


    return (
        <div>
            <div className={classes.root}>
                {openalert.open ?
                    <Snackbar
                        open={openalert.open} autoHideDuration={3000}
                        onClose={handleClose}>
                        <Alert
                            severity={"success"}
                            color={"info"}
                            variant="outlined">
                            Configuration Saved..
                        </Alert>
                    </Snackbar>
                    : null}
                <Snackbar
                    open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    onClose={handleClose}>
                    <Alert
                        severity="error"
                        color="error"
                        variant="filled">
                        {errorMessage.errmsg != null ? errorMessage.errmsg : " NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
                </Snackbar>
                <div className={classes.stepperdiv}>
                    <div>
                        <div>
                            <Button
                                size="small"
                                variant="contained"
                                color="secondary"
                                // disabled={activeStep === 0}
                                onClick={() => handleSaveClick()}
                                className={classes.backButton}
                                style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                startIcon={<SaveIcon />}
                            >
                                Save
                         </Button>
                            <Button variant="contained"
                                size="small"
                                style={{ fontSize: '0.700rem', fontWeight: 600 }}
                                color="primary"
                                onClick={() => handleNext('Back To Search Result')}
                                startIcon={<SettingsBackupRestoreIcon />}>
                                Back To Search Result
                                </Button>
                        </div>
                    </div>
                </div>
            </div>
            <br />

            <div style={{ marginTop: '40px' }}>
                <Card className={classes.cardroot}>
                    <CardContent>
                        <Typography variant="subtitle1" component="h2">
                            Create page Attributes
                            </Typography>
                        <Autocomplete
                            style={{ zIndex: 2000 }}
                            multiple
                            id="Select Attribute"
                            name="Attributes"
                            size="small"
                            options={AttributeList.AttributeList}
                            onChange={handleAttributes}
                            disableCloseOnSelect
                            getOptionLabel={option => option}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option}
                                </React.Fragment>
                            )}
                            renderInput={params => (
                                <TextField
                                    fullWidth
                                    {...params}
                                    variant="outlined"
                                    label="Attributes"
                                    size="small"
                                    placeholder="Add Attributes"
                                />
                            )}
                            value={userAttributes}
                        />

                        <br /> <br />
                        <Typography variant="subtitle1" component="h2">
                            No of columns
                            </Typography>

                        <TextField fullWidth
                            id="outlined-basic"
                            type="number"
                            label="No of columns"
                            variant="outlined"
                            size="small"
                            value={NoofColumns.NoofColumns}
                            onChange={(event) => handleColumns(event)}
                        />

                    </CardContent>
                </Card>

            </div>
        </div>
    )
}


